(() => {
  const sections = document.querySelectorAll('[data-fwg-section]');

  sections.forEach((section) => {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.setAttribute('data-fwg-visible', 'true');
          revealObserver.disconnect();
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    revealObserver.observe(section);

    const tempVisual = section.querySelector('.fwg-temp-visual');
    if (tempVisual) {
      const tempObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            section.setAttribute('data-fwg-bars-visible', 'true');
            tempObserver.disconnect();
          });
        },
        {
          threshold: 0.4
        }
      );

      tempObserver.observe(tempVisual);
    }
  });
})();
